<template>
  <div id="app" class="min-h-screen">
    <!-- Navigation -->
    <Navbar />

    <!-- Main Content -->
    <main>
      <!-- Hero Section -->
      <Hero />

      <!-- About Section -->
      <About />

      <!-- Products Section -->
      <Products />

      <!-- Contact Section -->
      <Contact />
    </main>

    <!-- Footer -->
    <Footer />

    <!-- WhatsApp Floating Button -->
    <WhatsAppButton />
  </div>
</template>

<script setup>
import Navbar from './components/Navbar.vue'
import Hero from './components/Hero.vue'
import About from './components/About.vue'
import Products from './components/Products.vue'
import Contact from './components/Contact.vue'
import Footer from './components/Footer.vue'
import WhatsAppButton from './components/WhatsAppButton.vue'
</script>
